<script>
  export let message
  export let style
  export let className = ''
  export let onClick = () => {}
</script>

<div on:click={onClick} class={className} {style}>{message}</div>
